/**
 *
 * @author Matthew Rawson @ 19/02/2018 10:30
 * @description
 * @notes
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import connect from "@irati/store/connect"

import DriverList from "./DriverList"
import DriverComment from "./DriverComment"

import {newComment, resetToDefaults, changeCopy} from "../../../store/actions/comment"

const Wrapper = styled.div`
  position: relative;
`

class Driver extends Component {
  static propTypes = {
    submittedDriverComments: PropTypes.array.isRequired,
    answerQuestion: PropTypes.func.isRequired,
    survey: PropTypes.object.isRequired,
    startNewComment: PropTypes.func.isRequired,
    updateCommentCopy: PropTypes.func.isRequired,
    resetCommentToDefaults: PropTypes.func.isRequired
  }
  static defaultProps = {}

  constructor(props) {
    super(props)
    const hasOnlyOneDriver = props.survey.drivers.length === 1
    const hasUnSavedComment = props.survey.comment.text
    if (hasOnlyOneDriver && !hasUnSavedComment) {
      props.startNewComment(props.survey.drivers[0])
    }
  }
  /**
   * Upon selecting a new driver, create a new comment in redux
   *
   * @param driver: object
   */
  handleDriverSelect = (driver) => {
    const {startNewComment} = this.props
    startNewComment(driver)
  }

  handleCommentChange = (comment) => {
    const {updateCommentCopy} = this.props
    updateCommentCopy(comment)
  }

  /**
   * Reset the comment state back to defaults
   */
  handleDriverOnBack = () => {
    const {resetCommentToDefaults} = this.props
    resetCommentToDefaults()
  }

  render() {
    const idNamespace = id("Driver", this.props)
    const {comment, drivers} = this.props.survey
    const hasOnlyOneDriver = this.props.survey.drivers.length === 1

    return (
      <Wrapper
        id={idNamespace}
        ref={(ref) => {
          this.ref = ref
        }}>
        {!comment.driver && <DriverList id={idNamespace} drivers={drivers} onDriverSelect={this.handleDriverSelect} />}

        {comment.driver && (
          <DriverComment
            id={idNamespace}
            comment={comment}
            onChange={this.handleCommentChange}
            onBack={this.handleDriverOnBack}
            hasOnlyOneDriver={hasOnlyOneDriver} />
        )}
      </Wrapper>
    )
  }
}

const mapStateToProps = ({survey}) => ({survey})
const mapDispatchToProps = (dispatch) => ({
  startNewComment: (driverId) => dispatch(newComment(driverId)),
  updateCommentCopy: (text) => dispatch(changeCopy(text)),
  resetCommentToDefaults: () => dispatch(resetToDefaults())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {withRef: true}
)(Driver)
